module.exports = __webpack_public_path__ + "static/handDeliveryImage-c674bd3248398b9695aea4570e79dec3.png";